import { z } from 'zod';

export const DealertrackScreenId = {
    DEAL_BUSINESS_OFFICE: 'DEAL_BUSINESS_OFFICE',
    LEASING: 'LEASING',
    CASHIER_LIST: 'CASHIER_LIST',
    CASHIER_PARTS: 'CASHIER_PARTS',
    CASHIER_SERVICE: 'CASHIER_SERVICE',
    PARTS_INVOICE_TRANSACTION: 'PARTS_INVOICE_TRANSACTION',
    REPAIR_ORDER_DETAIL: 'REPAIR_ORDER_DETAIL',
    REPAIR_ORDER_TOTALS: 'REPAIR_ORDER_TOTALS',
    HOME_SCREEN: 'HOME_SCREEN',
    PARTS_MENU: 'PARTS_MENU',
    CUSTOMER_SELECTION: 'CUSTOMER_SELECTION',
    CUSTOMER_HISTORY: 'CUSTOMER_HISTORY',
    UNKNOWN_CONTEXT: 'UNKNOWN_CONTEXT',
} as const;

export type DealertrackScreenId = (typeof DealertrackScreenId)[keyof typeof DealertrackScreenId];

export const DealertrackScreenIdValues: readonly DealertrackScreenId[] =
    Object.values(DealertrackScreenId);

export const DealertrackScreenIdSchema: z.ZodType<DealertrackScreenId> =
    z.enum(DealertrackScreenId);
